import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { orderingCalc } from 'src/api/cart';
import { CartOfferRequestDTO } from 'src/entities/cart/request/CartOfferRequestDTO';
import CartRequestDTO from 'src/entities/cart/request/CartRequestDTO';

let cartEpoch = 0;

/** The cart is left for good (R70 item 12: a saved offer) — calcs still on their way must not bring its goods back. */
export const leaveCart = (): void => {
    cartEpoch += 1;
};

/** orderingCalc for the cart as it is now; resolves to undefined when the cart was left while the calc ran. */
export function* calcCurrentCart(request: CartRequestDTO | CartOfferRequestDTO): SagaIterator {
    const startedIn = cartEpoch;
    const result = yield call(orderingCalc, request);
    if (startedIn !== cartEpoch) return undefined;
    // Live-Runde 10: the server echoes neither the unchecked vouchers nor the picked products — the
    // stored cart keeps them for the next request
    const data = result?.response?.data;
    if (data && typeof data === 'object' && request instanceof CartRequestDTO) {
        data.voucherChoice = {
            declined: request.declinedVoucherCodes ?? [],
            targets: request.voucherTargets ?? {},
        };
    }
    return result;
}
